import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get VoucherMode
export const getVoucherMode = createAsyncThunk("voucherMode/getVoucherMode", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getVoucherMode({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all VoucherMode
export const getAllVoucherMode = createAsyncThunk("voucherMode/getAllVoucherMode", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllVoucherMode();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("voucherMode/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("voucherMode/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "voucherMode/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageVoucherMode({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create VoucherMode
export const createVoucherMode = createAsyncThunk(
  "voucherMode/createVoucherMode",
  async (data, { rejectWithValue }) => {
    const { name, description } = data;
    try {
      const body = JSON.stringify({ name, description });
      const { data } = await API.createVoucherMode(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updateVoucherMode = createAsyncThunk(
  "voucherMode/updateVoucherMode",
  async (data, { rejectWithValue }) => {
    const { id, values } = data;
    const { name, description } = values;
    try {
      const body = JSON.stringify({ name, description });
      const { data } = await API.updateVoucherMode(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk("voucherMode/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
